import { useEffect, useState } from 'react';

export const useFocus = () => {
  const [ref, setRef] = useState<HTMLInputElement | null>(null);

  useEffect(() => {
    if (ref) {
      ref.focus();
    }
  }, [ref]);

  return setRef;
};
